import { render, staticRenderFns } from "./updateRecord.vue?vue&type=template&id=6c8b22b2&scoped=true"
import script from "./updateRecord.vue?vue&type=script&lang=js"
export * from "./updateRecord.vue?vue&type=script&lang=js"
import style0 from "./updateRecord.vue?vue&type=style&index=0&id=6c8b22b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b22b2",
  null
  
)

export default component.exports